import {
  C2CMode,
} from '../../components/common/configuration-settings/configuration-settings.models';

export const setOrderModalToStorage = (status: C2CMode) => {
  localStorage.setItem('ordersStatus', status);
};
